import { useContext, useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import admissionTitleSymbol from "../assets/admission-title-dut.svg";
import TitleSymbol from "../assets/black-dut-icon.svg";
import blackTitleSymbol from "../assets/bed-icon.svg";
import { CaseStageContext } from "../dashboard/cases/contexts/CaseContexts";

const sidebarData = [
  {
    title: "ADMISSION",
    stage: "admission",
    items: [
      "OPD Notes",
      "Labs",
      "Urine Culture Report",
      "CBC Report",
      "Blood Culture",
      "Imaging",
      "Patient KYC",
      "Doctor KYC",
      "Patient Photo",
      "MLC / FIR",
      "Implant",
      "Query Response",
      "Others",
      "Add Documents",
    ],
  },
  {
    title: "ENHANCEMENT",
    stage: "enhancement",
    items: [
      "Progress Notes",
      "Labs",
      "Imaging",
      "Patient Photo",
      "Doctor Photo",
      "Query",
      "Add Documents",
      "Others",
    ],
    enhancementCases: [
      {
        title: "Enhancement LOS",
        type: "AOP",
      },

      {
        title: "Enhancement 03",
        type: "AOP",
      },
      {
        title: "Enhancement 02",
        type: "AOP",
      },
      {
        title: "Enhancement 01",
        type: "LOS",
      },
    ],
  },
  {
    title: "DISCHARGE/CLAIM",
    stage: "discharge",
    items: [
      "Discharge Summary",
      "ICP Notes",
      "Treatment Plan",
      "Feedback",
      "Patient Photo",
      "Doctor Photo",
      "Labs",
      "Imaging",
      "O.T. Notes",
      "Others",
    ],
  },
  {
    title: "CLAIM QUERY",
    stage: "claim",
    items: ["Documents", "Query Response", "Others"],
  },
];

const ClaimSidebar = ({
  latestStageData,
  selectedDocument,
  setSelectedDocument,
  setSelectedImg,
}) => {
  const { caseStage, setCaseStage } = useContext(CaseStageContext);
  const [expanded, setExpanded] = useState({
    ADMISSION: caseStage?.includes("admission"),
    ENHANCEMENT: caseStage?.includes("enhancement"),
    "DISCHARGE/CLAIM": caseStage?.includes("discharge"),
    CLAIM: caseStage?.includes("claim"),
  });

  const currentDocuments = latestStageData?.documents || [];
  // const previousPendingDocuments =
  //   latestStageData?.previousPendingDocuments || [];
  const previousAllDocumentList =
    latestStageData?.previousAllDocumentList || [];

  const getDocumentsForSection = (sectionStage) => {
    const allDocuments = [...currentDocuments, ...previousAllDocumentList];

    switch (sectionStage) {
      case "admission":
        return allDocuments.filter(
          (doc) => doc.documentType === "ADMISSIONDOCUMENT",
        );

      case "enhancement":
        return allDocuments.filter(
          // (doc) => doc.documentType === "DURINGTREATMENTDOCUMENT",
          (doc) => doc.documentType.includes("ENHANCEMENT"),
        );

      case "discharge":
        return allDocuments.filter(
          (doc) => doc.documentType === "ONDISCHARGEDOCUMENT",
        );

      case "claim":
        return allDocuments.filter(
          (doc) =>
            doc.documentType?.includes("QUERY") ||
            doc.documentType?.includes("CLAIM"),
        );

      default:
        return [];
    }
  };

  const visibleSidebarData = sidebarData.filter((section) => {
    switch (caseStage?.toLowerCase()) {
      case "admission":
        return ["admission"].includes(section.stage);

      case "enhancement":
        return ["admission", "enhancement"].includes(section.stage);

      case "discharge":
        return ["admission", "enhancement", "discharge"].includes(
          section.stage,
        );

      case "claim":
        return ["admission", "enhancement", "discharge", "claim"].includes(
          section.stage,
        );

      default:
        return true;
    }
  });

  return (
    <div className="w-[168px] sticky top-[135px] bg-[#FFFFFF80] self-start flex flex-col gap-[12px] overflow-y-auto">
      {" "}
      {visibleSidebarData.map((section) => {
        const isOpen = expanded[section.title];
        const isAdmission = section.title === "ADMISSION";

        const sectionDocuments = getDocumentsForSection(section.stage);

        return (
          <div
            key={section.title}
            className={`overflow-hidden rounded-[24px] ${isOpen ? "bg-black" : "bg-white border border-[#D9D9D9]"}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => {
                // If only one sidebar is visible, allow toggle open/close
                if (visibleSidebarData.length === 1) {
                  setExpanded((prev) => ({
                    ...prev,
                    [section.title]: !prev[section.title],
                  }));
                  return;
                }

                // Existing behavior for multiple sections
                const newExpanded = {};

                sidebarData.forEach((item) => {
                  newExpanded[item.title] = false;
                });

                newExpanded[section.title] = true;

                setExpanded(newExpanded);
              }}
              className={`w-full h-[48px] px-[16px] flex items-center justify-between border-none ${isOpen ? "bg-black text-white rounded-t-[24px]" : isOpen ? "bg-white text-black" : "bg-white text-black rounded-[24px] border border-[#1A1A1A]"}`}
            >
              <span
                className={`flex items-center gap-[6px] font-lufga font-medium text-[12px] leading-[12px] tracking-[-0.03em] uppercase ${
                  isOpen ? "text-white" : "text-black"
                }`}
              >
                <img
                  src={isOpen ? blackTitleSymbol : TitleSymbol}
                  alt="section icon"
                  width={14}
                  height={14}
                />
                {section.title}
              </span>

              {isOpen ? (
                <KeyboardArrowUpIcon
                  sx={{
                    fontSize: "18px",
                    color: isAdmission ? "#FFFFFF" : "#1A1A1A",
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: "18px",
                    color: "#1A1A1A",
                  }}
                />
              )}
            </button>

            {isOpen && (
              <div
                className={`px-[12px] pt-[6px] pb-[12px] "bg-black text-white  font-light"`}
              >
                <div className="flex flex-col">
                  {" "}
                  {sectionDocuments.length > 0
                    ? sectionDocuments.map((doc) => {
                        let isRejected = doc?.documenturlmasters?.some(
                          (img) => img?.status === "REJECTED",
                        );
                        isRejected =
                          (doc?.aiReason?.aiStatus === "REJECTED" ||
                            isRejected) &&
                          doc?.status !== "APPROVED";

                        return (
                          <button
                            key={doc.id}
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();

                              setSelectedDocument(doc);

                              if (doc?.documenturlmasters?.length > 0) {
                                setSelectedImg({
                                  idx: 0,
                                  ...doc.documenturlmasters[0],
                                });
                              }

                              window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                              });
                            }}
                            className={`w-full text-left bg-transparent border-none mb-[10px] font-lufga leading-[12px] tracking-[-0.03em] transition-all duration-200 ${
                              selectedDocument?.id === doc.id
                                ? isRejected
                                  ? "text-[#FF4343] font-medium text-[14px] pl-[8px] border-l-[3px] border-[#FF4343]"
                                  : "text-white font-medium text-[14px] pl-[8px] border-l-[3px] border-[#5AC69F]"
                                : isRejected
                                  ? "text-[#FF4343] font-medium text-[12px]"
                                  : "text-white font-normal text-[12px]"
                            }`}
                          >
                            {doc.documentName}
                          </button>
                        );
                      })
                    : section.items.map((item, index) => (
                        <button
                          key={index}
                          type="button"
                          className="w-full text-left text-white bg-transparent border-none font-lufga text-[12px] leading-[12px] tracking-[-0.03em] mb-[10px]"
                        >
                          {item}
                        </button>
                      ))}
                  {section.enhancementCases?.map((enhancement, index) => (
                    <div
                      key={index}
                      className="w-full py-[8px] border-b border-[#5A5A5A]"
                    >
                      <button
                        type="button"
                        className="w-full flex items-center justify-between bg-transparent border-none p-0"
                      >
                        <div className="flex items-center gap-[2px]">
                          <span className="font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.03em] text-[#ffffff]">
                            {enhancement.title}
                          </span>

                          {enhancement.type && (
                            <span
                              className={`font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.03em] ${
                                enhancement.type === "AOP"
                                  ? "text-[#FF4D4F]"
                                  : "text-[#8B8B8B]"
                              }`}
                            >
                              {enhancement.type}
                            </span>
                          )}
                        </div>

                        <KeyboardArrowDownIcon
                          sx={{
                            fontSize: "16px",
                            color: "#1A1A1A",
                          }}
                        />
                      </button>
                      <div className="w-full h-[1px] bg-black"></div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ClaimSidebar;
